module.exports = __webpack_public_path__ + "img/Free Response 07.901f47f3.png";